export default function DSA_Selection_Sort_Time() {
  return <div>DSA_Selection_Sort_Time Component</div>;
}
